import { resolveRestoredBrandKitId, type BrandKitAccessData } from './brandKitAccess';

export interface InitialBrandKitCandidate extends BrandKitAccessData {
  is_default?: boolean | null;
}

/**
 * The kit a page selects when nothing was chosen: the default kit, else the
 * first personal kit, else the first public kit. `myBrandKits` is ordered
 * newest first, so that last case is the newest catalog template.
 */
export function pickFallbackBrandKitId(kits: readonly InitialBrandKitCandidate[]): string | null {
  const personalKits = kits.filter((kit) => !kit.is_public);
  const kit = personalKits.find((candidate) => candidate.is_default)
    ?? kits.find((candidate) => candidate.is_default)
    ?? personalKits[0]
    ?? kits[0];
  return kit?.id ?? null;
}

/**
 * The kit a clips page or the editor starts on. The template saved on the
 * project/library (chosen when the video was submitted) wins whenever the plan
 * can apply it; only then does the fallback apply.
 */
export function resolveInitialBrandKitId({
  savedBrandKitId,
  kits,
  hasProFeatures,
}: {
  savedBrandKitId: string | null | undefined;
  kits: readonly InitialBrandKitCandidate[];
  hasProFeatures: boolean;
}): string | null {
  return resolveRestoredBrandKitId({ hasProFeatures, brandKitId: savedBrandKitId, kits })
    ?? pickFallbackBrandKitId(kits);
}
